import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { localeApi } from 'common/modules/ReactShared';

const initialLocaleState = '';
const updateLocale = createAsyncThunk<string, string, { rejectValue: string }>(
  'user/locale/updateLocale_request',
  async (locale, { rejectWithValue }) => {
    try {
      await localeApi.setLocale(locale);
      return locale;
    } catch (error) {
      return rejectWithValue('en');
    }
  }
);

const localeSlice = createSlice({
  name: 'locale',
  initialState: initialLocaleState,
  reducers: {
    initLocale(_, action: PayloadAction<string>) {
      return action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(updateLocale.fulfilled, (_, action) => {
      return action.payload;
    });
    // Saving the locale failed (offline, a server error), not choosing it: show the requested one. Falling back to
    // `en` here sent `?locale=nb` round again, failing again, for ever.
    builder.addCase(updateLocale.rejected, (_, action) => {
      return action.meta.arg;
    });
  }
});

const { reducer, actions } = localeSlice;
export default reducer;

const userLocaleActions = { updateLocale, ...actions };
export { userLocaleActions };
